import { render, staticRenderFns } from "./ListOverlimitRequest.vue?vue&type=template&id=503aea72&"
import script from "./ListOverlimitRequest.vue?vue&type=script&lang=js&"
export * from "./ListOverlimitRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports